import { EChatActionTypes } from '../../actions/chat';
import { IAppState, IChatState, TActions } from '../../common/state';

export const defaultState: IChatState = {
  offer: null,
  isOpened: false,
};

export function chatReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case EChatActionTypes.Open: {
      return {
        ...state,
        chat: {
          offer: action.payload,
          isOpened: true,
        },
      };
    }
    case EChatActionTypes.Close: {
      return {
        ...state,
        chat: defaultState,
      };
    }
  }

  return state;
}
